import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Card, CardTitle, CardText } from 'reactstrap';
import { bindActionCreators } from 'redux';
import { redirectHandled }  from '../../util/helper'
import { CheckUserRole } from '../CheckUserRole';
import { ROLES } from '../../constants/roles';
import * as BuscaActions from '../../store/ducks/protocolo/busca/actions'
import "./_style.scss";

class Dashboard extends Component {
  constructor(props) {
    super(props);
    this.state = { ...this.props };

    let match = this.props.location.pathname ? this.props.location.pathname.split('/') : ''

    if (match[1].toUpperCase() === 'FORMALIZACAO') {
      const userKey = '_nscorporate_user';
      let usernew = JSON.parse(sessionStorage.getItem(userKey));
      usernew.current_idaplicacao = "E42EEFB0-FF92-4C59-BB0D-B8E41CFBDF5A";
      usernew.current_idaplicacaocliente = "82CECB94-1945-45B7-AFE0-E2DBA1AF21CB";
      sessionStorage.setItem(userKey, JSON.stringify(usernew));
    }

  }

  componentWillUnmount() {
    this.props.actions.clear();
  }

  componentDidMount() {
    this.props.actions.searchTotais()
  }

  gotToPage = (page) => {
    redirectHandled(this.props.history, page)
  }

  cards = () => {
    return (
        <div className="d-flex justify-content-center">
            <Card 
            className="m-5 py-5 text-center cards-dashboard card-danger"  
            onClick={() => this.gotToPage('/protocolo/envio/principal')}
            >
            <span className="title-card-dashboard">
            {this.props.protocolo_totais.pendente_protocolo === 0 ? "0" : this.props.protocolo_totais.pendente_protocolo}
            </span>
            <span className="label-card-dashboard">
            Pendente de Protocolo
            </span>
        </Card>
            <Card 
              className="m-5 py-5  text-center cards-dashboard"
              onClick={() => this.gotToPage('/protocolo/consulta')}
              >
            <span className="title-card-dashboard">
            {this.props.protocolo_totais.pendente_recepcao === 0 ? "0" : this.props.protocolo_totais.pendente_recepcao}
            </span>
            <span className="label-card-dashboard">
            Pendente de Recepção
            </span>
        </Card>
            <Card 
              className="m-5 py-5 text-center cards-dashboard card-danger"  
              onClick={() => this.gotToPage('/contrato/consulta')}
            >
            <span className="title-card-dashboard">
            {this.props.protocolo_totais.pendente_impeditivo === 0 ? "0" : this.props.protocolo_totais.pendente_impeditivo}
            </span>
            <span className="label-card-dashboard">
            Pendências Impeditivas
            </span>
        </Card>
      </div>
    )
  }

  render() {

    return (
      <div className="animated fadeIn">
        <Container>
          <CheckUserRole role={ROLES.FORMALIZACAO.DASHBOARD}>
            {this.cards()}
          </CheckUserRole>
        </Container>
      </div >
    );
  }
}

const mapStateToProps = state => ({
  protocolo_totais: state.protocoloBusca
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(BuscaActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps)
  (Dashboard);